























import { listFactory } from '@/main/pages';

import { number } from '@storybook/addon-knobs';

import { formatDate } from '@/main/utils/dateFormatter';

import { NAME } from './constants';
import { DropDownListItem, store } from './store/list';
import { apiProvider } from './api';

export default listFactory(NAME, store).extend({

	data() {
		return {
			parameters: 'null' as string,
			selectedWorkshops: [] as number[],
		};
	},
	mounted() {
		const element = document.getElementsByClassName('el-main');
		if (element.length != 0) element[0].classList.remove('d-flex');		
	},
	methods: {

		async exportFun() {
			try {
				const columnsSeq = this.table.columns.filter(x => x.isVisible === true).map(x => x.columnName);
				this.startLoading();
				const urlParameters: string = this.GetParameters(this.filter.FromDate, this.filter.ToDate, this.filter.LocationIds);
				await apiProvider.GetTechnicianClockingReport(urlParameters, columnsSeq);
			} finally {
				this.endLoading();
			}
		},

		GetParameters(FromDate : any, ToDate : any, LocationIds: any) {
			const fromDatetime = formatDate(FromDate);
			const toDatetime = formatDate(ToDate);
			this.parameters = '';
			this.parameters = this.parameters.concat(`FromDate=${fromDatetime}&ToDate=${toDatetime}&LocationIds=${LocationIds}`);
			return this.parameters;
		},

		dateValidation() {
			if (this.FromDate && this.ToDate) {
				const startMonth = this.FromDate.getMonth();
				const endMonth = this.ToDate.getMonth();
				const startYear = this.FromDate.getFullYear();
				const endYear = this.ToDate.getFullYear();
				if (startMonth !== endMonth || startYear !== endYear) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('DP_DATETOFROM_MONTH_VALIDATION') });
					const date = new Date();
					this.FromDate = new Date(date.getFullYear(), date.getMonth(), 1);
					this.ToDate = date;
					return false;
				}
				if (this.FromDate > this.ToDate) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('FROMDATESHOULDBELESSTHANTODATE') });
					return false;
				}
			} else {
				return false;
			}
			return true;
		},
	},
});
